import React, { useState } from 'react';
import { Linkedin, MessageCircle, Link2, Check } from 'lucide-react';

// Small "X" (Twitter) logo — lucide doesn't ship one, so use an inline SVG for consistency
const XIcon = ({ className }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" className={className}>
    <path d="M18.244 2H21l-6.62 7.56L22 22h-6.828l-4.77-6.253L4.8 22H2l7.08-8.087L2 2h6.914l4.31 5.706L18.244 2zm-1.196 18h1.52L7.03 4H5.43l11.618 16z" />
  </svg>
);

const BASE = 'https://verifaeye.com.au';

export default function GuideShareRow({ slug, title }) {
  const [copied, setCopied] = useState(false);
  const url = `${BASE}/guides/${slug}`;
  const shareText = `${title} — VerifAEye`;

  const share = (network) => {
    const encoded = encodeURIComponent(url);
    const encodedText = encodeURIComponent(shareText);
    const targets = {
      linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encoded}`,
      x: `https://twitter.com/intent/tweet?text=${encodedText}&url=${encoded}`,
      whatsapp: `https://api.whatsapp.com/send?text=${encodedText}%20${encoded}`,
    };
    if (targets[network]) window.open(targets[network], '_blank', 'noopener,noreferrer,width=600,height=600');
  };

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch {
      /* clipboard blocked — silently ignore */
    }
  };

  const btn = 'inline-flex items-center justify-center w-9 h-9 rounded-full border border-slate-200 text-slate-600 hover:text-slate-900 hover:border-slate-300 transition';

  return (
    <div className="flex items-center gap-2" data-testid="guide-share-row">
      <span className="text-xs uppercase tracking-wider text-slate-400 mr-1 hidden sm:inline">Share</span>
      <button type="button" onClick={() => share('linkedin')} data-testid="share-linkedin" aria-label="Share to LinkedIn" className={btn}>
        <Linkedin className="w-4 h-4" />
      </button>
      <button type="button" onClick={() => share('x')} data-testid="share-x" aria-label="Share to X" className={btn}>
        <XIcon className="w-3.5 h-3.5" />
      </button>
      <button type="button" onClick={() => share('whatsapp')} data-testid="share-whatsapp" aria-label="Share to WhatsApp" className={btn}>
        <MessageCircle className="w-4 h-4" />
      </button>
      <button type="button" onClick={copy} data-testid="share-copy" aria-label="Copy link" className={btn}>
        {copied ? <Check className="w-4 h-4 text-emerald-600" /> : <Link2 className="w-4 h-4" />}
      </button>
      {copied && <span className="text-xs text-emerald-600" data-testid="share-copied">Link copied</span>}
    </div>
  );
}
